import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { AbstractControl, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.css'],
})
export class SingleSelectComponent {
  @Input() subtitle?: string;
  @Input() infoText?: string;
  @Input() label?: string;
  @Input() isTimeInput: boolean = false;
  @Input() inBrackets?: string;
  @Input() formCtrl!: FormControl;
  @Input() options: any[] = [];
  @Input() value: any;
  @Input() property?: string;
  @Input() initialIndex: number = 0;
  @Input() showIcon = false;
  @Input() filled = false;
  @Input() webIcon = false;
  @Input() border = 'none';
  @Input() showSearch = false;
  @Input() disabled = false;
  @Input() showTrailingAction = false;
  @Input() trailingActionIcon = 'edit';
  @Input() trailingActionTooltip = '';
  @Input() trailingActionDisabled = false;

  @Output() subtitleTapped: EventEmitter<any> = new EventEmitter();
  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() trailingActionTapped: EventEmitter<void> = new EventEmitter();

  @ViewChild('matSelect') matSelect?: MatSelect;
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;
  searchFormControl: FormControl = new FormControl();
  searchActive = false;
  filteredOptions: any[] = [];
  preprocessedOptions: any[] = [];

  constructor(public datePipe: DatePipe, private sanitizer: DomSanitizer) {}

  getOptionIcon(option: any): string | null {
    if (!this.showIcon) return null;
    return this.webIcon
      ? option.icon
      : `../assets/social/${option[this.property ?? '']}.png`;
  }

  selection(event: any) {
    this.selected.emit(event.value);

    setTimeout(() => {
      this.searchActive = false;
      this.searchFormControl.setValue('');
    }, 200);
  }

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && this.options) {
      this.options = [...this.options];
    }
  }

  formatTime(time: number): string {
    const hours = Math.floor(time);
    const minutes = Math.floor((time - hours) * 60);
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
  }

  get isMandatory() {
    if (this.formCtrl) {
      const validator = this.formCtrl.validator
        ? this.formCtrl.validator({} as AbstractControl)
        : null;
      if (validator && validator['required']) {
        return true;
      }
    }
    return false;
  }

  onTypeSearch(): void {
    let searchTerm = this.searchFormControl.value?.toLowerCase();
    this.searchActive = searchTerm !== '';

    if (this.searchActive) {
      this.filteredOptions = this.options.filter((el) => {
        if (this.property) {
          return el[this.property]?.toLowerCase().includes(searchTerm);
        } else {
          return el?.toLowerCase().includes(searchTerm);
        }
      });
    }
  }

  onDropdownOpenedChange(isOpen: boolean): void {
    if (isOpen && this.showSearch && this.searchInput) {
      setTimeout(() => {
        this.searchInput?.nativeElement.focus();
      }, 0);
    }
  }

  onTrailingActionClick(event: Event): void {
    event.stopPropagation();
    this.trailingActionTapped.emit();
  }
}
